import { ConfirmDeleteDialog } from "@/components/shared/ConfirmDeleteDialog";
import { toast } from "@/hooks/use-toast";
import { brandApi } from "@/resources/brand";

export interface DeleteBrandTarget {
  id: number;
  name: string;
}

interface DeleteBrandDialogProps {
  brand: DeleteBrandTarget | null;
  onCancel: () => void;
  onDeleted?: () => void;
}

export function DeleteBrandDialog({ brand, onCancel, onDeleted }: DeleteBrandDialogProps) {
  const { mutate: deleteBrand, isPending } = brandApi.useDeleteBrand();

  const handleDelete = () => {
    if (!brand) return;
    deleteBrand(brand.id, {
      onSuccess: () => {
        toast({
          title: "Brand Deleted",
          description: `"${brand.name}" and all its Hero ASINs have been removed.`,
        });
        onDeleted?.();
      },
    });
  };

  return (
    <ConfirmDeleteDialog
      open={!!brand}
      onOpenChange={(open) => { if (!open) onCancel(); }}
      title={`Delete "${brand?.name}"?`}
      description={`This will permanently delete "${brand?.name}" and all its associated Hero ASINs and data. This action cannot be undone.`}
      isPending={isPending}
      onConfirm={handleDelete}
    />
  );
}
